import React, { Component } from 'react';
import { Button, Row, Col, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import BlockUi from 'react-block-ui';

class GroupConfirmation extends Component {

    constructor(props) {

        super(props)

        this.state = {
            loading: false
        }
    }

    setLoading(value) {
        this.setState({
            loading: value
        });
    }

    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.toggleModal} size="md" backdrop="static">
                <BlockUi tag="div" blocking={this.state.loading} color="#009ef7" message={this.props.t("pleasewait")}>
                    <Modal.Header>
                        <Modal.Title><FontAwesomeIcon icon={duotone("warning")} /> {this.props.t("warning")}</Modal.Title>
                        <OverlayTrigger
                            placement="left"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip style={{ position: "fixed" }}>
                                {this.props.t("close")}
                            </Tooltip>}>
                            <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                        </OverlayTrigger>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col>
                                {
                                    (!this.props.disabled) &&
                                    <p>{this.props.t("youareaboutdisable")} {this.props.group}</p>
                                }
                                {
                                    (this.props.disabled) &&
                                    <p>{this.props.t("youareaboutenable")} {this.props.group}</p>
                                }
                                <p>{this.props.t("areyousure")}</p>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={this.props.enableQueue}>
                            <FontAwesomeIcon icon={duotone("paper-plane-top")} /> {this.props.t("ok")}
                        </Button>
                    </Modal.Footer>
                </BlockUi>
            </Modal>
        )
    }
}



export default withTranslation()(GroupConfirmation);